// Flujo — draws the connecting rail (left → right) once the steps scroll into
// view. The .is-revealed class flips the ::before from scaleX(0) to scaleX(1)
// (CSS handles the transition). Steps themselves animate via AOS.
document.addEventListener('DOMContentLoaded', function () {
  const groups = document.querySelectorAll('.flujo-steps')
  if (!groups.length) return

  if (!('IntersectionObserver' in window)) {
    groups.forEach((el) => el.classList.add('is-revealed'))
    return
  }

  const io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed')
          obs.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.25 }
  )

  groups.forEach((el) => io.observe(el))
})
